import AppLogo from '../assets/svgs/app-logo.svg';
import keysCircle from '../assets/images/keys-circle.png';
import TwitterIcon from '../assets/svgs/icons/twitter-icon.svg';
import DiscordIcon from '../assets/svgs/icons/discord.svg';
import BgLineLeft from '../assets/images/bg-lines-left.png';
import BgLineRight from '../assets/images/bg-lines-right.png';
import BgLinesTop from '../assets/images/bg-lines-top.png';
import BgLinesBottom from '../assets/images/bg-lines-bottom.png';
import keysCircleMobile from '../assets/images/keys-circle-mobile.png';

const ComingSoon_v2 = () => {
  return (
    <>
      <div className="min-h-[100dvh] bg-black flex flex-col">
        <header className="z-10 w-full px-[60px] py-[23px] fixed top-0">
          <img src={AppLogo} alt="App Logo" className="sm:mx-0 mx-auto" />
        </header>

        <main className="flex-1 flex items-center justify-center overflow-hidden relative">
          <img
            src={BgLinesTop}
            alt="Bg Line Left"
            className="absolute top-0 w-full lg:hidden select-none"
          />

          <img
            src={BgLinesBottom}
            alt="Bg Line Right"
            className="absolute bottom-0 w-full lg:hidden select-none"
          />

          <div className="max-w-[1095px] mx-auto relative">
            <img
              src={BgLineLeft}
              alt="Bg Line Left"
              className="absolute top-0 bottom-0 m-auto left-[-25%] lg:block hidden select-none"
            />

            <img
              src={BgLineRight}
              alt="Bg Line Right"
              className="absolute top-0 bottom-0 m-auto right-[-25%] lg:block hidden select-none"
            />

            <img
              src={keysCircle}
              alt="Keys Circle"
              className="lg:block hidden select-none keys-blast"
            />

            <img
              src={keysCircleMobile}
              alt="Keys Circle"
              className="lg:hidden block select-none keys-blast-mobile"
            />

            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col gap-y-5 items-center sm:bottom-[130px] bottom-[90px]">
              <h1 className="uppercase text-[44.9448px] md:text-[90px] font-joystix text-white tracking-[-0.04em] min-w-max">
                Looty is <br /> <span className="gradient-text">evolving</span>
              </h1>

              <div className="space-y-2">
                <p className="text-xs sm:text-[15px] md:text-[22px] font-medium text-[#CFCFCF] text-center tracking-[-0.4px]">
                  Built like a game, run like a protocol
                </p>

                <p className="text-xs sm:text-[15px] md:text-[22px] font-medium text-[#CFCFCF] text-center tracking-[-0.4px]">
                  Stay tuned! Exciting things are <br className="md:hidden block" />
                  on the way!
                </p>
              </div>

              <div className="flex gap-3 items-center md:flex-row flex-col">
                <a
                  href="https://discord.gg/TCj8UyAVhB"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="border border-[#414141] rounded-xl p-1 flex items-center gap-x-2.5 h-10 overflow-hidden md:min-w-fit min-w-[151.05px] justify-between hover:border-[#5A5A5A] transition-colors"
                >
                  <div className="md:px-2.5 md:w-fit w-[101.65px] leading-none h-full flex items-center justify-center bg-[#121212] md:text-sm text-[13.3px] text-white rounded-lg transition-all duration-300">
                    Our Discord
                  </div>

                  <img src={DiscordIcon} alt="Discord Icon" className="pr-1.5" />
                </a>

                <a
                  href="https://x.com/Looty_fi"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="border border-[#414141] rounded-xl p-1 flex items-center gap-x-2.5 h-10 overflow-hidden md:min-w-fit min-w-[151.05px] justify-between hover:border-[#5A5A5A] transition-colors"
                >
                  <div className="md:px-2.5 md:w-fit w-[101.65px] leading-none h-full flex items-center justify-center bg-[#121212] md:text-sm text-[13.3px] text-white rounded-lg transition-all duration-300">
                    Visit on X
                  </div>

                  <img src={TwitterIcon} alt="Twitter Icon" className="pr-1.5" />
                </a>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default ComingSoon_v2;
